import { useNotificationsUnreadCountQuery } from '../api/repositories/use-notifications-unread-count.query';
import { useWebSocketContext } from '../context/notifications-web-socket-context';
import styles from './styles.module.scss';
import clsx from 'clsx';
import { useDrawer } from 'components/drawer-wrapper-component/drawer-wrapper-component';
import { InlineSvg } from 'components/svg';
import { useAuth } from 'features/auth/contexts/auth';
import { useEffect, useState } from 'react';

export const ButtonWidget = () => {
  const { subscribe, unsubscribe } = useWebSocketContext();

  const { toggleDrawer } = useDrawer();
  const { currentUser } = useAuth();
  const [countMessages, setCountMessages] = useState<number>(0);

  useNotificationsUnreadCountQuery(undefined, {
    enabled: !!currentUser,
    onSuccess: (data) => {
      setCountMessages(data ?? 0);
    }
  });

  useEffect(() => {
    if (!subscribe || !unsubscribe) return;

    const handleUserCountNotification = (data: number) => {
      setCountMessages(data);
    };

    subscribe('usercountnotification', handleUserCountNotification);

    return () => {
      unsubscribe('usercountnotification', handleUserCountNotification);
    };
  }, [subscribe, unsubscribe]);

  if (!currentUser) return null;

  return (
    <button className={clsx(styles.container)} onClick={() => toggleDrawer(1)}>
      <InlineSvg path="/media/icons/custom/notify.svg" />
      {(countMessages ?? 0) > 0 ? <div className={clsx(styles.countMessages)}>{countMessages}</div> : null}
    </button>
  );
};
